import React from "react";
import { MoveInConditionCreateScreenContainer } from "src/containers";

export const MoveInConditionCreateScreen = () => {
  return <MoveInConditionCreateScreenContainer />;
};
